import { NurseLayout } from "@/components/layout/nurse-layout";
import { EventsList } from "@/components/events/events-list";

export default function NurseEvents() {
  return (
    <NurseLayout title="Events">
      <EventsList
        intro="BSR conferences, EULAR congresses, NRAS webinars, RCN forums, and more — all UK rheumatology CPD and professional development events in one place."
        accentBg="bg-teal-100"
        accentIcon="text-teal-700"
        accentLink="text-teal-600 hover:text-teal-800"
      />
    </NurseLayout>
  );
}
